import { CityPageBlock } from "../types";
import Hero from "./blocks/Hero";
import Advantages from "./blocks/Advantages";
import PropertyList from "./blocks/PropertyList";
import TextWithImage from "./blocks/TextWithImage";
import Reviews from "./blocks/Reviews";
import Faq from "./blocks/Faq";
import Contact from "./blocks/Contact";

interface BlockRendererProps {
  blocks: CityPageBlock[] | undefined;
}

export default function BlockRenderer({ blocks }: BlockRendererProps) {
  if (!blocks || blocks.length === 0) {
    return null;
  }

  return (
    <>
      {blocks.map((block) => {
        switch (block._type) {
          case "heroBlock":
            return <Hero key={block._key} block={block} />;
          case "advantagesBlock":
            return <Advantages key={block._key} block={block} />;
          case "propertyListBlock":
            return <PropertyList key={block._key} block={block} />;
          case "textWithImageBlock":
            return <TextWithImage key={block._key} block={block} />;
          case "reviewsBlock":
            return <Reviews key={block._key} block={block} />;
          case "faqBlock":
            return <Faq key={block._key} block={block} />;
          case "contactBlock":
            return <Contact key={block._key} block={block} />;
          default:
            // Safely handle unknown block types (e.g. if schema updates but frontend lags)
            if (process.env.NODE_ENV === "development") {
              return (
                <div
                  key={block._key}
                  className="p-4 bg-red-100 text-red-700 border border-red-300 m-4 rounded"
                >
                  Unknown Block Type: {block._type}
                </div>
              );
            }
            return null;
        }
      })}
    </>
  );
}

